/* global axios */
import ApiClient from '../ApiClient';

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    // Use V1 for subscription management (not enterprise namespace)
    super('', { accountScoped: true, enterprise: false, apiVersion: 'v1' });
  }

  /**
   * Open the self-serve billing portal for the current customer
   */
  openBillingPortal() {
    return axios.get(`${this.url}subscriptions/customer_portal`);
  }

  /**
   * Legacy alias retained for older callers.
   * @deprecated Use openBillingPortal() instead
   */
  checkout() {
    return this.openBillingPortal();
  }

  /**
   * Legacy V1 subscription endpoint - redirects to V2
   * @deprecated Use getSubscriptions() instead
   */
  subscription() {
    return this.getSubscriptions();
  }

  getSubscriptions() {
    return axios.get(`${this.url}subscriptions`);
  }

  getSubscription(id) {
    return axios.get(`${this.url}subscriptions/${id}`);
  }

  createSubscription(params) {
    return axios.post(`${this.url}subscriptions`, params);
  }

  updateSubscription(id, params) {
    return axios.patch(`${this.url}subscriptions/${id}`, params);
  }

  deleteSubscription(id, reason) {
    return axios.delete(`${this.url}subscriptions/${id}`, {
      data: { reason },
    });
  }

  /**
   * Create a checkout session for subscription or Sage Credits top-up
   */
  createCheckout(params) {
    return axios.post(`${this.url}subscriptions/checkout`, params);
  }

  /**
   * Get customer portal URL
   */
  getCustomerPortal() {
    return axios.get(`${this.url}subscriptions/customer_portal`);
  }

  /**
   * Create a Polar customer
   */
  createCustomer() {
    return axios.post(`${this.url}subscriptions/create_customer`);
  }

  getInvoices() {
    return axios.get(`${this.url}subscriptions/invoices`);
  }

  getLimits() {
    // Limits is still V1
    const v1Url = this.url.replace('v2/', '');
    return axios.get(`${v1Url}limits`);
  }

  toggleDeletion(action) {
    // Toggle deletion is still V1
    const v1Url = this.url.replace('v2/', '');
    return axios.post(`${v1Url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(credits, product_id) {
    return axios.post(`${this.url}subscriptions/topup_checkout`, {
      credits,
      product_id,
    });
  }

  /**
   * Regenerate checkout session for incomplete trial subscription
   * Creates a fresh checkout URL every time the user clicks "Start Free Trial"
   */
  regenerateCheckout() {
    return axios.post(`${this.url}subscriptions/regenerate_checkout`);
  }

  /**
   * Refresh subscription data from Polar (trust Polar over local DB)
   */
  refreshSubscription() {
    return axios.get(`${this.url}subscriptions/refresh`);
  }

  getAffiliateProgram() {
    return axios.get(`${this.url}affiliate_program`);
  }

  joinAffiliateProgram() {
    return axios.post(`${this.url}affiliate_program`);
  }
}

export default new EnterpriseAccountAPI();
